import Message from "../../message";
import {useMainStore} from "@/store";

export default class GuildMotdChanged extends Message
{
    handle()
    {
        useMainStore().SET_GUILD_MOTD(this.message.motd);
    }
}
